import { ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import EligibilityQuiz from '../components/EligibilityQuiz';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_270b8cc9-1693-407c-b15e-5414d2b83f2e/artifacts/qe9vta95_LOGO-FIRMA-PNG-1-branco-258x278-1%20%282%29.png";

// Booking page: the qualification quiz lives here (not on the landing page) so the
// prospect only fills it out after deciding they want the call. The quiz captures the
// lead (Meta CAPI + GHL) and then routes to /thank-you for calendar scheduling.
export default function BookingPage() {
  // Return links go back to whichever landing page sent the prospect here
  // (passed via navigate state); defaults to the root LP.
  const location = useLocation();
  const homePath = location.state?.from || '/';

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="booking-page">
      {/* Header */}
      <header className="py-6 border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to={homePath} className="flex items-center gap-3" data-testid="logo-link">
            <img src={LOGO_URL} alt="Firma Medical Growth" className="h-12 w-auto invert" />
            <span className="text-sm font-medium text-[#0A0A0A]">Medical Growth Systems</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-12 lg:py-16">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="heading-lg mb-4" data-testid="booking-headline">
              You're One Step Away From a Predictable Patient Pipeline
            </h1>
            <p className="body-lg text-[#6B7280]" data-testid="booking-subheadline">
              Answer 3 quick questions so we can prepare for your call — then pick a time that works for you.
            </p>
          </div>

          <div className="form-container">
            <EligibilityQuiz id="booking-quiz" />
          </div>

          <div className="text-center mt-8">
            <Link
              to={homePath}
              className="inline-flex items-center gap-2 text-sm text-[#6B7280] hover:text-[#0A0A0A] transition-colors"
              data-testid="return-home"
            >
              <ArrowLeft className="w-4 h-4" />
              Return to Homepage
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs text-[#6B7280]">
            © {new Date().getFullYear()} Firma Medical Growth Systems. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
